export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '网页版免费91真的完全免费吗？',
    answer: '是的，网页版免费91平台上所有工具和服务均完全免费。我们通过广告和合作伙伴支持运营，不会向用户收取任何费用。您可以放心使用所有功能，无需担心隐藏收费或强制订阅。',
  },
  {
    question: '使用网页版免费91需要注册账号吗？',
    answer: '大部分基础功能无需注册即可直接使用。如果您希望保存使用记录、创建个性化歌单或同步跨设备数据，注册一个免费账号会带来更好的体验。注册过程简单快捷，只需提供邮箱即可。',
  },
  {
    question: '网页版免费91支持哪些设备和浏览器？',
    answer: '网页版免费91支持所有主流浏览器，包括Chrome、Firefox、Safari、Edge等。同时完美适配Windows、Mac、Linux电脑以及iOS和Android移动设备。我们推荐使用最新版本的浏览器以获得最佳体验。',
  },
  {
    question: '上传的文件安全吗？会被泄露吗？',
    answer: '我们非常重视用户数据安全。所有上传的文件都采用端到端加密传输，处理完成后会在规定时间内自动从服务器彻底删除。我们承诺不会存储、查看或分享您的任何文件内容。',
  },
  {
    question: '网页版免费91的在线工具与桌面软件相比有什么优势？',
    answer: '在线工具的主要优势在于无需下载安装、不占用本地存储空间、跨平台使用、自动更新。您无需担心软件版本和兼容性问题，只要有网络就能使用最新版本的工具。此外，在线工具通常更轻量，对设备配置要求更低。',
  },
  {
    question: '如果遇到使用问题，如何获取帮助？',
    answer: '您可以通过平台的帮助中心查找常见问题的解决方案。如果帮助中心无法解决您的问题，可以通过关于我们页面的联系方式与我们取得联系，我们的客服团队会在工作时间内尽快回复您。',
  },
  {
    question: '平台上的游戏内容适合儿童吗？',
    answer: '网页版免费91平台上的所有内容都经过严格审核。游戏内容会标注适合年龄段，家长可以根据标注为孩子选择合适的游戏。我们建议家长陪同儿童使用平台，并合理安排使用时间。',
  },
];